<template>
  <div id="container">
    <div class="control">
      <div class="title">Role</div>
      <div class="content">{{ position.selectedRole.prettyName }}</div>
    </div>
    <div class="control">
      <div class="title">Duty</div>
      <div class="content">{{ position.selectedRole.duty }}</div>
    </div>
    <div class="control">
      <div class="title">Mentality</div>
      <div class="content">-</div>
    </div>
    <div class="control">
      <div class="title">Instructions for:</div>
      <div class="content">{{ position.positionName }}</div>
    </div>
    <div hidden class="role-description">
      The Inside Forward aims to cut inside from the flanks and run directly at the...
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: Object,
  }
}
</script>

<style scoped>
#container {
  display: flex; 
  flex-wrap: wrap;
  padding-bottom: 16px;
}

.control {
  width: 25%;
}

.title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: small;
}

.content {
  font-size: medium;
  font-weight: 600;
  padding: 8px 0;
}

.role-description {
  width: 100%;
  text-align: center;
  opacity: 0.52;
  margin: 12px 0;
  padding: 8px 8px 12px;
  background: #242424;
  border-radius: 12px;
}
</style>
